export const getTextColor = (bgColor, blackColor, whiteColor) => {
  if (!bgColor) return '#000000'
  // let color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor
  // let r = parseInt(color.substring(0, 2), 16)
  // let g = parseInt(color.substring(2, 4), 16)
  // let b = parseInt(color.substring(4, 6), 16)
  // let uicolors = [r / 255, g / 255, b / 255]
  // let c = uicolors.map(col => {
  //   if (col <= 0.03928) {
  //     return col / 12.92
  //   }
  //   return Math.pow((col + 0.055) / 1.055, 2.4)
  // })
  // let L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]

  //v2 follow wheel gettextcolor
  const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor
  const r = parseInt(color.substring(0, 2), 16) // hexToR
  const g = parseInt(color.substring(2, 4), 16) // hexToG
  const b = parseInt(color.substring(4, 6), 16) // hexToB
  if (r * 0.299 + g * 0.587 + b * 0.114 > 150) {
    return blackColor || '#000000'
  } else {
    return whiteColor || '#FFFFFF'
  }
}
